var _path, _circle, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9 6.9C20.6 6.3 19.2 5.9 17.7 5.7L17.3 6.5C15.7 6.3 14.3 6.3 12.7 6.5L12.3 5.7C10.8 5.9 9.4 6.3 8.1 6.9C5.6 10.7 4.9 14.4 5.2 18.1C6.9 19.4 8.8 20.4 10.9 21L11.8 19.5C10.9 19.2 10 18.8 9.2 18.2C9.4 18.1 9.6 17.9 9.8 17.8C12.9 19.3 17.1 19.3 20.2 17.8C20.4 17.9 20.6 18.1 20.8 18.2C20 18.8 19.1 19.2 18.2 19.5L19.1 21C21.2 20.4 23.1 19.4 24.8 18.1C25.2 13.8 24.1 10.1 21.9 6.9Z",
    fill: "url(#discordGradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14.5,
    r: 1.5,
    fill: "#1A0C00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14.5,
    r: 1.5,
    fill: "#1A0C00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "discordGradient",
    x1: 5,
    y1: 5,
    x2: 25,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF6A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C4B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.e1f52aaa756ef96d8cf8ca2310ebfdbd.svg";
export { ForwardRef as ReactComponent };